import useMountEffect from '@restart/hooks/useMountEffect';
import { RiCameraLensLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import useCameraCommand from '@/hooks/command/mavlink/useCameraCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeMavLinkCommand } from '@/utils/CommandUtils';

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const cameraCommand = useCameraCommand();

  useMountEffect(() => {
    robots.forEach((robot) => process(robot));

    dispatch(actions.command.resetActivePanels());
  });

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeMavLinkCommand(robot, cameraCommand.shoot());

      onSuccess(robot);
    } catch (error) {
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  const onSuccess = (robot) => {
    notifier.success(`${robot.name} captured photo successfully.`);
  };

  const onFailure = (robot) => {
    notifier.error(`Failed to capture photo on ${robot.name}.`);
  };
  //#endregion

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Shoot';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiCameraLensLine;
Command.Panel = Panel;

export default Command;
